import { Calls as CallsComponent } from '@components/Calls/Calls'

export const Calls = () => {
  return <CallsComponent />
}
